import PurchasingOptionsPhotoPreview from './PurchasingOptionsPhotoPreview';

export default PurchasingOptionsPhotoPreview;
